var v1="<div gnp-stroke-analysis=\"\" stroke-data=\"::rstCtrl.strokeData\"></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("round-detail/round-stroke-chart/round-stroke-chart.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/round-detail/round-stroke-chart/round-stroke-chart.jade
// module id = 578
// module chunks = 0